import React, { useState, useEffect } from "react";
import config from "../../../config/domain";

import { NavLink } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";
// exact activeClassName="active"

const HeaderUnauth = ({ isNavbar, showNavbar }) => {
  return (
    <div className="navbar-menu">
      <div className={isNavbar ? "mobileView" : "hide_nav"}>
        <div>
          <ul onClick={showNavbar}>
            <li className="nav-sub-container">
              <a href="javascript:void(0)">Documentation</a>
              <ul className="nav-sublink">
                <li>
                  <a
                    target="_blank"
                    rel=" noreferrer"
                    href={config.jmw_client_docs}
                  >
                    Client Documentation
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel=" noreferrer"
                    href={config.jmw_partner_docs}
                  >
                    Partner Documentation
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                Resources
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                Support
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      <ul className="destopView">
        <li className="nav-sub-container">
          {/* href="https://ewuat.edelbusiness.in/library-documentation/" */}
          <a href="javascript:void(0)">Documentation</a>
          <ul className="nav-sublink">
            <li>
              <a target="_blank" rel="noreferrer" href={config.jmw_client_docs}>
                Client Documentation
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_partner_docs}
              >
                Partner Documentation
              </a>
            </li>
          </ul>
        </li>
        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
            Resources
          </NavLink>
        </li>
        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
            Support
          </NavLink>
        </li>
        <li>
          <NavLink
            exact
            activeClassName="active"
            to={RoutesUrl.Signup}
            className="btn"
          >
            Sign-up
          </NavLink>
        </li>
        <li className="noRightMargin nav-sub-container">
          <a href="javascript:void(0)" className="border-btn ">
            Login
          </a>
          <ul className="nav-sublink">
            <li>
              <NavLink to={RoutesUrl.ClientLogin}>Client Login</NavLink>
            </li>
            <li>
              <NavLink to={RoutesUrl.VendorLogin}>Partner Login</NavLink>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default HeaderUnauth;
